import DesignSection from 'records/DesignSection';
import Base from 'records/Base';

import {
  DESIGN_SECTION_ASYNC_ACTION_START,
  DESIGN_SECTION_ASYNC_ACTION_ERROR,
  DESIGN_SECTION_ASYNC_ACTION_SUCCESS,
  DESIGN_SECTION_UPDATE_ACTION_SUCCESS,
  DESIGN_SECTION_RESET_STATE,
} from 'actions/designSection';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new DesignSection(),
});

const actionsMap = {
  [DESIGN_SECTION_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [DESIGN_SECTION_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [DESIGN_SECTION_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new DesignSection(action.data),
    });
  },
  [DESIGN_SECTION_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new Base({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [DESIGN_SECTION_RESET_STATE]: () => {
    return initialState;
  },
};

export default function designSection(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
